'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$CreateUPCP(username, password, pin, base64Cert) {
  this.Zw = null;
  this.Zu = null;
  this.Zv = null;
  this.Zt = null;
  this.Zw = username;
  this.Zu = password;
  this.Zv = pin;
  this.Zt = base64Cert;
}
export { $c_Lpresto_types$proto$CreateUPCP as $c_Lpresto_types$proto$CreateUPCP };
$p = $c_Lpresto_types$proto$CreateUPCP.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$CreateUPCP;
/** @constructor */
function $h_Lpresto_types$proto$CreateUPCP() {
}
export { $h_Lpresto_types$proto$CreateUPCP as $h_Lpresto_types$proto$CreateUPCP };
$h_Lpresto_types$proto$CreateUPCP.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$CreateUPCP) && ((((this.Zw === x$0.Zw) && (this.Zu === x$0.Zu)) && (this.Zv === x$0.Zv)) && (this.Zt === x$0.Zt))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 4;
});
$p.s = (function() {
  return "CreateUPCP";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Zw;
      break;
    }
    case 1: {
      return this.Zu;
      break;
    }
    case 2: {
      return this.Zv;
      break;
    }
    case 3: {
      return this.Zt;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$proto$CreateUPCP(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kU)));
}
export { $isArrayOf_Lpresto_types$proto$CreateUPCP as $isArrayOf_Lpresto_types$proto$CreateUPCP };
var $d_Lpresto_types$proto$CreateUPCP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$CreateUPCP, "presto.types$proto$CreateUPCP", ({
  kU: 1,
  bx: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$CreateUPCP as $d_Lpresto_types$proto$CreateUPCP };
//# sourceMappingURL=presto.types$proto$-Create-U-P-C-P.js.map
